import { connect } from 'react-redux';
import Pendings from './Pendings';
import { actions } from '../../../redux/modules/pendings';
import {resetStore} from "../../../redux/modules/login";


const ms2p = (state) => {
    return {
        ...state.pendings,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(Pendings);
